import { useCallback } from 'react';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';
import { useQueryParamValue } from 'src/app/shared/hooks/location';
import { useCurrentUserIdAsync } from 'src/app/shared/hooks/session';
import type { ShareAction, ShareChannel } from 'src/app/shared/hooks/share';
import { useAvailableShareActionsAsync } from 'src/app/shared/hooks/share';
import { isLoaded } from 'src/app/shared/utils/async';

export function useQRCodeShare(): ShareAction | null {
	const {
		data: {
			petition: {
				id: petitionId,
				user: { id: userId },
			},
		},
	} = usePetitionDetailsPageData();
	const sourceLocation = useQueryParamValue('source_location');
	const currentUserState = useCurrentUserIdAsync();
	const currentUserId = isLoaded(currentUserState) ? currentUserState.value : undefined;

	const getTrackingData = useCallback(
		(_channel: ShareChannel) => ({
			location: 'qr_code_download',
			view_context: 'petition_details',
			own_petition: userId === currentUserId,
			context: 'petition_details',
			petition_id: `petition_${petitionId}`,
			source_location: sourceLocation,
		}),
		[currentUserId, petitionId, userId, sourceLocation],
	);

	// We only use the share action helper to handle the share tracking.
	// The short URL is built by the QR generator in GraphQL.
	const channels = ['qrcode'] as const;
	const actionsState = useAvailableShareActionsAsync(channels, {
		trackingEventName: 'share_petition',
		getUrl: (_channel: ShareChannel) => '',
		getTrackingData,
		getContent: (_channel: ShareChannel) => '',
		disableShortLinks: true,
	});
	return isLoaded(actionsState) ? actionsState.actions[0] : null;
}
